import { styled } from '@ori-ui/mui';

import { SEARCH_PREVIEW_IMAGE_SIZE, SEARCH_PREVIEW_IMAGE_WRAPPER_HEIGHT } from './constants';

export const Root = styled('img')({
  height: SEARCH_PREVIEW_IMAGE_SIZE,
  width: SEARCH_PREVIEW_IMAGE_SIZE,
  minWidth: SEARCH_PREVIEW_IMAGE_SIZE,
});

export const ImageWrapper = styled('div')(({ theme }) => ({
  background: theme.palette.grey[100],
  borderRadius: theme.shape.borderRadius,
  height: SEARCH_PREVIEW_IMAGE_WRAPPER_HEIGHT,
  width: SEARCH_PREVIEW_IMAGE_SIZE,
  padding: theme.spacing(3, 0),
  boxSizing: 'border-box',
}));
